"use strict";
/*
 * IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: IBM Cognos Analytics
 *
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordInput = exports.ControlledPasswordInput = exports.TextInput = void 0;
const tslib_1 = require("tslib");
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const react_1 = tslib_1.__importDefault(require("react"));
const carbon_components_react_1 = require("carbon-components-react");
const utils_1 = require("../utils");
const TEXTINPUT_COMPONENT_NAME = 'TextInput';
const TEXTINPUT_DISPLAY_NAME = (0, utils_1.getDisplayName)(TEXTINPUT_COMPONENT_NAME);
const TEXTINPUT_DEFAULT_TID = (0, utils_1.getDefaultTid)(TEXTINPUT_COMPONENT_NAME);
exports.TextInput = react_1.default.forwardRef((props, ref) => {
    const { 
    // remove - remapped and local props
    'data-tid': dataTid, id } = props, 
    // pass all other props to Carbon
    otherCarbonProps = tslib_1.__rest(props, ['data-tid', "id"]);
    const mappedProps = {
        'data-tid': dataTid !== null && dataTid !== void 0 ? dataTid : TEXTINPUT_DEFAULT_TID,
        id: id !== null && id !== void 0 ? id : (0, utils_1.getUniqueId)(TEXTINPUT_DISPLAY_NAME),
    };
    if (ref) {
        mappedProps.ref = ref;
    }
    return react_1.default.createElement(carbon_components_react_1.TextInput, Object.assign({}, otherCarbonProps, mappedProps));
});
exports.TextInput.propTypes = {
    'data-tid': prop_types_1.default.string,
    id: prop_types_1.default.string,
};
exports.TextInput.displayName = TEXTINPUT_DISPLAY_NAME;
const CONTROLLEDPASSWORDINPUT_COMPONENT_NAME = 'ControlledPasswordInput';
const CONTROLLEDPASSWORDINPUT_DISPLAY_NAME = (0, utils_1.getDisplayName)(CONTROLLEDPASSWORDINPUT_COMPONENT_NAME);
const CONTROLLEDPASSWORDINPUT_DEFAULT_TID = (0, utils_1.getDefaultTid)(CONTROLLEDPASSWORDINPUT_COMPONENT_NAME);
exports.ControlledPasswordInput = react_1.default.forwardRef((props, ref) => {
    const { 
    // remove - remapped and local props
    'data-tid': dataTid, id } = props, 
    // pass all other props to Carbon
    otherCarbonProps = tslib_1.__rest(props, ['data-tid', "id"]);
    const mappedProps = {
        'data-tid': dataTid !== null && dataTid !== void 0 ? dataTid : CONTROLLEDPASSWORDINPUT_DEFAULT_TID,
        id: id !== null && id !== void 0 ? id : (0, utils_1.getUniqueId)(CONTROLLEDPASSWORDINPUT_DISPLAY_NAME),
    };
    if (ref) {
        mappedProps.ref = ref;
    }
    return react_1.default.createElement(carbon_components_react_1.TextInput.ControlledPasswordInput, Object.assign({}, otherCarbonProps, mappedProps));
});
exports.ControlledPasswordInput.propTypes = {
    'data-tid': prop_types_1.default.string,
    id: prop_types_1.default.string,
};
exports.ControlledPasswordInput.displayName = CONTROLLEDPASSWORDINPUT_DISPLAY_NAME;
const PASSWORDINPUT_COMPONENT_NAME = 'PasswordInput';
const PASSWORDINPUT_DISPLAY_NAME = (0, utils_1.getDisplayName)(PASSWORDINPUT_COMPONENT_NAME);
const PASSWORDINPUT_DEFAULT_TID = (0, utils_1.getDefaultTid)(PASSWORDINPUT_COMPONENT_NAME);
exports.PasswordInput = react_1.default.forwardRef((props, ref) => {
    const { 
    // remove - remapped and local props
    'data-tid': dataTid, id } = props, 
    // pass all other props to Carbon
    otherCarbonProps = tslib_1.__rest(props, ['data-tid', "id"]);
    const mappedProps = {
        'data-tid': dataTid !== null && dataTid !== void 0 ? dataTid : PASSWORDINPUT_DEFAULT_TID,
        id: id !== null && id !== void 0 ? id : (0, utils_1.getUniqueId)(PASSWORDINPUT_DISPLAY_NAME),
    };
    if (ref) {
        mappedProps.ref = ref;
    }
    return react_1.default.createElement(carbon_components_react_1.TextInput.PasswordInput, Object.assign({}, otherCarbonProps, mappedProps));
});
exports.PasswordInput.propTypes = {
    'data-tid': prop_types_1.default.string,
    id: prop_types_1.default.string,
};
exports.PasswordInput.displayName = PASSWORDINPUT_DISPLAY_NAME;
